/** Notifications list (QM-D14-001): deep links open the item (QM-D19-002); mark read / all read. */
import { useState } from 'react';
import { Link } from 'react-router';
import type { Notification } from '@qm/contracts/notifications';
import { Badge, Button, EmptyState, ErrorState, Heading, Loading } from '@qm/ui';
import { useApp } from '../../../lib/app-context';
import { bffJson } from '../../../lib/bff';
import { useFormat } from '../../../lib/format';
import { useResource } from '../../../lib/resource';

export function NotificationsPage() {
  const { t } = useApp();
  const f = useFormat();
  const res = useResource<Notification[]>('/v1/notifications');
  const [read, setRead] = useState<Set<string>>(new Set());
  const markAll = async () => { await bffJson('/v1/notifications/read-all', 'POST').catch(() => undefined); res.reload(); };
  const open = (n: Notification) => { setRead((s) => new Set(s).add(n.id)); void bffJson(`/v1/notifications/${encodeURIComponent(n.id)}/read`, 'POST').catch(() => undefined); };
  const text = (n: Notification) => t(n.messageKey, Object.fromEntries(Object.entries(n.params).map(([k, v]) => [k, f.text(v)])));
  return (
    <section className="qm-page" aria-labelledby="page-title">
      <div className="qm-page__head">
        <Heading level={1} id="page-title">{t('notifications.title')}</Heading>
        <div className="qm-row">
          <Link to="/settings#notifications">{t('notifications.prefs.title')}</Link>
          <Button onClick={() => void markAll()}>{t('notifications.markAllRead')}</Button>
        </div>
      </div>
      {res.status === 'loading' ? <Loading label={t('common.loading')} /> : res.status === 'error' ? <ErrorState message={t('shell.error.load')} /> : !res.data.length ? <EmptyState title={t('notifications.empty')} /> : (
        <ul className="qm-list">
          {res.data.map((n) => {
            const unread = !n.readAt && !read.has(n.id);
            return (
              <li key={n.id} className="qm-list__item" data-unread={unread ? 'true' : undefined}>
                <span>
                  {unread ? <span className="qm-sr-only">{t('notifications.unread', { count: 1 })} </span> : null}
                  {n.link ? <Link to={n.link} onClick={() => open(n)}><bdi>{text(n)}</bdi></Link> : <bdi>{text(n)}</bdi>}
                </span>
                <span className="qm-row">
                  {n.mandatory ? <Badge tone="warning">{t('notifications.mandatory')}</Badge> : null}
                  <Badge>{t(`notifications.category.${n.category}`)}</Badge>
                  <time dateTime={n.createdAt}>{f.dateTime(n.createdAt)}</time>
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
